import { hasProperty } from './hasProperty';
import { isPrimitive } from './isPrimitive';
/**
 * Принимает на вход неизвестный формат данных и отдает объект, подходящий для сериализации в JSON.
 * @param data Исходные данные
 * @returns Отфильтрованные данные, подходящие для сериализации
 */
export function toSerializableObject(data) {
    return toSerializableObjectSafe(data, new Set());
}
function isSerialazablePrimitive(value) {
    return isPrimitive(value) && typeof value !== 'symbol' && typeof value !== 'bigint';
}
function toSerializableObjectSafe(data, processedObjects) {
    if (isSerialazablePrimitive(data)) {
        return data;
    }
    if (typeof data === 'symbol' || typeof data === 'bigint') {
        return data.toString();
    }
    if (data instanceof Array) {
        if (processedObjects.has(data)) {
            return '[Circular reference to Array]';
        }
        processedObjects.add(data);
        const serializedArray = data.reduce((acc, el) => {
            acc.push(toSerializableObjectSafe(el, processedObjects));
            return acc;
        }, []);
        return serializedArray;
    }
    if (data instanceof Object) {
        if (processedObjects.has(data)) {
            return `[Circular reference to ${data}]`;
        }
        if (data instanceof Function) {
            return `[Function ${data.name ? data.name : 'anonymous'}]`;
        }
        processedObjects.add(data);
        const serialized = {};
        for (const key of Object.getOwnPropertyNames(data)) {
            if (!hasProperty(data, key)) {
                continue;
            }
            const value = data[key];
            serialized[key] = toSerializableObjectSafe(value, processedObjects);
        }
        return serialized;
    }
    return undefined;
}
